type MajorVersion = "0" | "1" | "2" | "3";
type VersionsData =
  | Record<MajorVersion, unknown>
  | (Partial<Record<MajorVersion, unknown>> & {
      default: unknown;
    });

export const sdkSelect = (versionsData: VersionsData) => {
  const urlParams = new URLSearchParams(window.location.search);
  const sdkVersion = urlParams.get("version");
  const majorVersion = sdkVersion?.split("@")[1][0];

  if (majorVersion && versionsData[majorVersion]) {
    return versionsData[majorVersion];
  }

  if ("default" in versionsData) {
    return versionsData.default;
  }

  // If no version is found, throw an error
  throw new Error(
    `SDK version ${sdkVersion} not supported and no default fallback was provided. Supported versions are: ${Object.keys(
      versionsData
    ).join(", ")}`
  );
};
